module.exports = __webpack_public_path__ + "static/media/path0102.43967b19.jpg";